<template>
  <div>
    <el-empty :description="description"></el-empty>
  </div>
</template>

<script>
export default {
  name: 'PageError',
  props: {
    description: {
      type: String
    }
  }
}
</script>
